/* <ldy-card> + phone quick-add sheet + quick view loader. Hearts: localStorage ldy-saved, ldy:saved event. */
(() => {
  if (customElements.get('ldy-card')) return;
  const KEY = 'ldy-saved';
  const $$ = (root, s) => root.querySelectorAll(s);
  const tpl = () => document.querySelector('template[data-ldy-sheet]');
  const str = (k, v) => (tpl()?.dataset[k] || '').replace('%s', v);
  const esc = (s) => String(s).replace(/[&<>"']/g, (c) => `&#${c.charCodeAt(0)};`);
  const label = (s) => s.replace(/-/g, '–');

  const getSaved = () => {
    try {
      return JSON.parse(localStorage.getItem(KEY)) || [];
    } catch {
      return [];
    }
  };
  const syncHearts = (list) => {
    for (const b of $$(document, 'ldy-card [data-save]')) {
      b.ariaPressed = list.includes(b.closest('ldy-card').dataset.handle);
    }
  };
  function toggleSaved(handle) {
    const old = getSaved();
    const on = !old.includes(handle);
    const list = on ? [handle, ...old].slice(0, 60) : old.filter((h) => h !== handle);
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch {
      /* storage blocked */
    }
    document.dispatchEvent(new CustomEvent('ldy:saved', { detail: { handle, saved: on, list } }));
    return on;
  }
  document.addEventListener('ldy:saved', (e) => syncHearts(e.detail.list));
  /* Shared with the product page heart (assets/ldy-product.js) */
  window.ldySaved = { get: getSaved, toggle: toggleSaved };

  const single = (v) => v.length === 1 && !v[0][0];
  const sizeBtn = ([s, id, ok]) =>
    `<button type="button" class="ldy-size" data-id="${id}" data-size="${esc(s)}" aria-label="${esc(
      str(ok ? 'addSize' : 'soldOut', label(s)),
    )}"${ok ? '' : ' disabled'}>${esc(label(s))}</button>`;
  const sizesHTML = (v) =>
    single(v)
      ? `<button type="button" class="button ldy-card__bag" data-id="${v[0][1]}"${v[0][2] ? '' : ' disabled'}>${esc(str('add'))}</button>`
      : v.map(sizeBtn).join('');

  class LdyCard extends HTMLElement {
    connectedCallback() {
      if (this.img !== undefined) return;
      this.img = this.querySelector('.ldy-card__img');
      syncHearts(getSaved());
      this.addEventListener('click', this);
    }

    get data() {
      this.d ||= JSON.parse(this.querySelector('[data-card-json]')?.textContent || '{"c":[]}').c;
      return this.d;
    }

    get color() {
      return this.data.find((c) => c[0] === this.dataset.color) || this.data[0];
    }

    url(path, w) {
      if (!path) return '';
      const u = path.includes('//') ? path : `${this.img.getAttribute('src').split('/cdn/shop/')[0]}/cdn/shop/${path}`;
      return `${u}${u.includes('?') ? '&' : '?'}width=${w}`;
    }

    handleEvent(e) {
      const b = e.target.closest('button');
      const d = b?.disabled ? {} : b?.dataset || {};
      if (d.swatch != null) this.setColor(d.swatch);
      else if (d.save != null) toggleSaved(this.dataset.handle) && window.ldyCommerce?.burst(b);
      else if (d.id) this.add(+d.id, d.size, b);
      else if (d.plus != null) openSheet(this, b);
      else if (d.view != null)
        quickView().then(
          (qv) => qv.open(this, b),
          () => (location.href = this.dataset.url),
        );
    }

    setColor(name) {
      const c = this.data.find((x) => x[0] === name);
      if (!c) return;
      this.dataset.color = name;
      for (const s of $$(this, '[data-swatch]')) s.ariaPressed = s.dataset.swatch === name;
      if (this.img && c[1]) {
        this.img.srcset = [360, 600, 900].map((w) => `${this.url(c[1], w)} ${w}w`).join();
        this.img.src = this.url(c[1], 600);
        this.img.alt = `${this.dataset.title}, ${name}`;
      }
      const v = c[2].find((x) => x[2]) || c[2][0];
      for (const a of $$(this, 'a')) a.href = `${this.dataset.url}?variant=${v[1]}`;
      const row = this.querySelector('[data-sizes]');
      if (row) row.innerHTML = sizesHTML(c[2]);
    }

    add(id, size, b) {
      const c = this.color;
      if (this.busy || !window.ldyCommerce) return;
      this.busy = b.ariaBusy = true;
      window.ldyCommerce
        .add([{ id }], {
          sourceImg: this.img,
          title: this.dataset.title,
          detail: [c?.[0], size && label(size)].filter(Boolean).join(', '),
          image: this.url(c?.[1], 120),
        })
        .catch(() => {}) /* ldyCommerce shows the error toast */
        .finally(() => {
          this.busy = b.ariaBusy = null;
        });
    }
  }
  customElements.define('ldy-card', LdyCard);

  /* Quick view (eye): its CSS + JS load once, on the first tap. Failing that, the eye opens the product page. */
  let qvLoad;
  const load = (el) =>
    new Promise((ok, fail) => {
      el.onload = ok;
      el.onerror = fail;
      document.head.append(el);
    });
  function quickView() {
    const t = document.querySelector('template[data-ldy-qv]');
    if (!t) return Promise.reject(new Error('quick view is off'));
    qvLoad ||= Promise.all([
      load(Object.assign(document.createElement('link'), { rel: 'stylesheet', href: t.dataset.css })),
      load(Object.assign(document.createElement('script'), { src: t.dataset.js })),
    ])
      .then(() => window.ldyQuickView)
      .catch((e) => {
        qvLoad = null;
        console.error('[ldy] quick view', e);
        throw e;
      });
    return qvLoad;
  }

  /* Phone sheet: one modal <dialog> per page from <template data-ldy-sheet> */
  let dlg;
  let cur;
  let opener;
  const $ = (s) => dlg.querySelector(s);
  function draw() {
    const c = cur.color;
    $('img').hidden = !c[1];
    $('img').src = cur.url(c[1], 240);
    $('h2').textContent = cur.dataset.title;
    $('[data-price]').innerHTML = cur.querySelector('.ldy-card__price')?.outerHTML || '';
    $('[data-colors]').hidden = cur.data.length < 2;
    $('[data-cname]').textContent = c[0];
    $('[data-sw]').innerHTML = cur.data
      .map(
        (x) =>
          `<button type="button" class="ldy-swatch" style="--c:${esc(x[3])}" aria-label="${esc(x[0])}" aria-pressed="${x === c}" data-swatch="${esc(x[0])}"></button>`,
      )
      .join('');
    $('[data-sl]').hidden = single(c[2]);
    $('[data-sizes]').innerHTML = sizesHTML(c[2]);
    $('[data-link]').href = cur.querySelector('.ldy-card__link').href;
  }
  function onSheetClick(e) {
    if (e.target === dlg) return dlg.close(); /* scrim */
    const b = e.target.closest('button');
    const d = b?.disabled ? {} : b?.dataset || {};
    if (d.close != null) dlg.close();
    else if (d.swatch != null) {
      cur.setColor(d.swatch);
      draw();
      $(`[data-swatch="${CSS.escape(d.swatch)}"]`).focus();
    } else if (d.id) {
      dlg.close();
      cur.add(+d.id, d.size, b);
    }
  }
  function openSheet(card, button) {
    if (!card.color || !tpl()) return;
    if (!dlg) {
      dlg = tpl().content.firstElementChild.cloneNode(true);
      dlg.addEventListener('click', onSheetClick);
      dlg.addEventListener('close', () => opener.isConnected && opener.focus({ preventScroll: true }));
      document.body.append(dlg);
    }
    cur = card;
    opener = button;
    dlg.classList.toggle('is-anim', window.ldy?.motion !== false);
    draw();
    dlg.showModal();
    ($('[data-id]:not([disabled])') || $('[data-close]')).focus();
  }
})();
